<template>
  <div class="animated fadeIn">
      <spinner v-if="loading"/>
    <b-card>
        <div slot="header">
          <strong>Search WTO</strong>
        </div>
        <b-row>
            <b-col sm="3">
                <b-form-group>
                    <label for="wto_num">WTO No</label>
                        <b-form-input type="text" id="wto_num" v-model="filter.wto_num"></b-form-input>
                </b-form-group>
            </b-col>
            <b-col sm="3">
                <b-form-group>
                    <label for="country_id">Country</label>
                    <countryLookup v-bind:url="apiCountryLookup" v-on:selected="setCountry($event)" :lookupId="filter.country_id"/>
                </b-form-group>
            </b-col>
            <b-col sm="2">
              <b-form-group>
                  <label for="date_start">Date Start</label>
                      <b-form-input type="date" v-model="filter.date_start"></b-form-input>
              </b-form-group>
            </b-col>
          <b-col sm="2">
              <b-form-group>
                  <label for="date_end">Date End</label>
                      <b-form-input type="date" v-model="filter.date_end"></b-form-input>
              </b-form-group>
          </b-col>
          <b-col sm="2">
            <b-form-group>
                  <label for="status">Status</label>
                      <b-form-select id="status" v-model="filter.status"
                            :plain="true"
                            :options="['','OPEN', 'CLOSE', 'MANUAL-CLOSED']"
                            value="">
                      </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <div slot="footer">
            <b-button type="submit" size="lg" variant="primary" @click="search">Search</b-button>
            &nbsp;&nbsp;
            <b-button type="submit" size="lg" variant="success" @click="newWTO">New WTO</b-button>
        </div>
    </b-card>
    <b-row v-if="getRowCount(searchResults) > 0 && !loading ">
        <b-col sm="12" >
          <b-card>
              <div slot="header">
                  <strong>Search Results</strong>
              </div>
              <b-table class="table-hover" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :fields="searchResultsFields" :current-page="currentPage" 
              :per-page="perPage" :items="searchResults" @row-clicked="rowClick">
              </b-table>
            <nav>
              <b-pagination :total-rows="getRowCount(searchResults)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
            </nav>
            <div slot="footer">
                <exportExcel class   = "btn btn-primary btn-lg" size ="lg" :data   = "searchResults" :fields = "exportHeaders" name = "wto.xls">
                    Export to Excel
                </exportExcel>
                &nbsp;
              <b-button type="submit" size="lg" variant="success" @click="print">Print</b-button>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-row v-else-if="noResults" >
            <b-col sm="12">
              <div align="center">
                <strong>No WTO Found</strong>
              </div>                    
            </b-col>
      </b-row>
  </div>
</template>
<script>
import axios from 'axios'
import spinner from '@/components/Spinner.vue'
import countryLookup from '@/components/Autocomplete.vue'
import {authHeader, apiCountryLookup} from '@/functions/common.vue'
import {apiWtoSearch} from '@/functions/common.vue'
import exportExcel from 'vue-json-excel'
import pdfMake from "pdfmake/build/pdfmake";
  import pdfFonts from "pdfmake/build/vfs_fonts";
  pdfMake.vfs = pdfFonts.pdfMake.vfs;
  pdfMake.fonts = {
      "ukai": {
         normal: 'ukai.ttf',
          bold: 'ukai.ttf',
          italics: 'ukai.ttf',
           bolditalics: 'ukai.ttf'
      },
   };
export default 
  {
    components:{spinner,countryLookup,exportExcel},
    props: {
      caption: 
      {
        type: String,
        default: 'Table'
      },
      hover: 
      {
        type: Boolean,
        default: false
      },
      striped: 
      {
        type: Boolean,
        default: false
      },
      bordered: 
      {
        type: Boolean,
        default: false
      },
      small: 
      {
        type: Boolean,
        default: false
      },
      fixed: 
      {
        type: Boolean,
        default: false
      }
    },
    data: () => {
      return {
        apiCountryLookup:apiCountryLookup,
        loading: false,
        noResults: false,
        filter: 
          {
            wto_num: '',
            country_id: '',
            date_start: '',
            date_end: '',
            status:''
          },  
        searchResults: [],
        searchResultsFields: 
        [
          {key: 'country_id', label: 'Country Code'},
          {key: 'from_location_id' ,label: 'Location From'},
          {key: 'to_location_id' ,label: 'Location To'},
          {key: 'wto_date' ,label: 'Date'},
          {key: 'wto_num' ,label: 'WTO No',sortable: true},
          {key: 'remarks',label:'Remarks'},
          {key: 'reason',label: 'Reason'},
          {key: 'author_user_shortname' ,label: 'Created By'}
        ],
        currentPage: 1,
        perPage: 20,
        totalRows: 0,
        noResults: false,
        exportHeaders:
        {
          'WTO No': 'wto_num',
          'Date': 'wto_date',
          'Country': 'country_id',
          'Location From': 'from_location_id',
          'Location To': 'to_location_id',
          'Status':'status',
          'Remarks':'remarks',
          'Reason':'reason',
          'Created By':'author_user_shortname',
        },
      }
    },
    methods: 
    {
      print()
      {
            var rows = []
            var row = []
            var date = new Date()
            rows.push([
            'WTO No',
            'Date',
            'Country Code',
            'Location From',
            'Location To',
            'Status',
            'Remarks',
            'Reason',
            'Created By'
            ])

            for (let key in this.searchResults)
            {
              var data = this.searchResults[key]
              var ref = '-'
              var reason = '-'
              if(data.reason != '')
              {
                reason = data.reason
              }
              if(data.remarks != '')
              {
                ref = data.remarks
              }
              row = [data.wto_num, data.wto_date,data.country_id,data.from_location_id,data.to_location_id,data.status,ref,reason,data.author_user_shortname]
              rows.push(row)
            }
            var dd = {
              header:{ text: 'Warehouse Transfer Order List generated on'+ " "+ date, margin: [ 5, 10, 10, 30 ],alignment: 'center',fontSize:8 },
              pageSize: 'A4',
              pageOrientation: 'landscape',
            
              // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
              pageMargins: [30, 30, 30, 20 ],
              defaultStyle: {
                font: 'ukai'
              },
              content: [
                {
                  fontSize: 9,
                  layout: 'lightHorizontalLines', // optional
                  table: 
                  {
                    // headers are automatically repeated if the table spans over multiple pages
                    // you can declare how many rows should be treated as headers
                    headerRows: 1,
                    widths: [ 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 280,'auto', 'auto' ],
                    body: 
                      rows
                  }
                }
              ]
            };

            pdfMake.createPdf(dd).open();
      },
      getRowCount (items) 
      {
        return items.length
      },
      search()
      {
        this.noResults =true
        if (1)
        {
          this.loading = true
          var sf =
          [
            "wto_num LIKE " + this.filter.wto_num
            ,"country_id = " + this.filter.country_id
            ,"wto_date >= " + this.filter.date_start
            ,"wto_date <= " + this.filter.date_end
            ,"status = " + this.filter.status
          ]

          axios.post(apiWtoSearch, sf)
            .then (res => 
            {
                return res
            })
            .then (data =>
            {
                const resultArray = []
                const myData = data.data.data.list
                for (let key in myData)
                {
                    var date = myData[key].wto_date
                    var date = new Date(date);
                    var result = "" + (date.getDate() > 9 ? '' : '0') + date.getDate() + '/'+  ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear()
                    myData[key].wto_date=result
                    if(myData[key].remarks == '')
                    {
                      myData[key].remarks = '-'
                    }
                    if(myData[key].reason == '')
                    {
                      myData[key].reason = '-'
                    }
                    resultArray.push(myData[key])
                    this.loading = false
                }
                this.searchResults = resultArray
                
                if(this.searchResults.length ==0)
                {
                    this.loading = false
                    this.noResults =true
                }
            })
            .catch(error => alert(error)) 
        }
      },
      newWTO()
      {
        this.$router.push({ name: 'Warehouse Transfer Order Entry (WTO)', params: { wtoNum: '_new' }})
      },
      setCountry(obj)
      {
            var id
            if (obj !== null)
            {
              id = obj.id
            } 
            else
            {
              id = null
            }
            this.filter.country_id = id
      },
      rowClick(item)
      {
        this.$router.push({ name: 'Warehouse Transfer Order Entry (WTO)', params: { wtoNum: item.wto_num }}) 
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/wto/wtos.vue